/* eslint-disable */
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const HobbiesModal = ({ userHobbies, setuserHobbies }) => {
  const hobbiesText = "";

  const [hobbiesBlock, setHobbiesBlock] = useState([]);

  const addNewHobbiesBlock = () => {
    setHobbiesBlock([...hobbiesBlock, hobbiesText]);
  };

  const deleteHobbiesBlock = (index) => {
    const deleteHobbiesArr = [...hobbiesBlock];
    deleteHobbiesArr.splice(index, 1);
    setHobbiesBlock(deleteHobbiesArr);
  };

  //function for change survey select
  const hobbiesInputHandler = (index, field, value) => {
    const updatedFormValues = hobbiesBlock.map((block, i) =>
      index == i ? (block = value) : block
    );

    setHobbiesBlock(updatedFormValues);
  };

  const updatedHobbiesBlock = (updatedData) => {
    setHobbiesBlock(updatedData);
  };

  const saveInfoHandler = () => {
    if (hobbiesBlock.length > 0) {
      setuserHobbies(hobbiesBlock);
    } else {
      setuserHobbies([]);
    }

    resetHandler();

    let loginModal = document.querySelector("#hobbies_modal");
    let modal = bootstrap.Modal.getInstance(loginModal);
    modal.hide();
  };

  const resetHandler = () => {
    setHobbiesBlock([]);
  };

  useEffect(() => {
    if (userHobbies.length > 0) {
      updatedHobbiesBlock(userHobbies);
    } else {
      updatedHobbiesBlock([]);
    }
  }, [userHobbies]);

  return (
    <div
      className="modal fade"
      id="hobbies_modal"
      tabIndex="-1"
      aria-labelledby="addDetailsLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h3 className="modal-title">Hobbies</h3>

            <button
              type="button"
              className="btn-close p-0 bg-gray-200 rounded-circle shadow-none m-0"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="form_innr">
                <div className="form-group mb-3">
                  {hobbiesBlock.map((hobbiesData, index) => {
                    return (
                      <div
                        className="d-flex align-items-center gap-1 mb-2"
                        key={index}
                      >
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Links"
                          value={hobbiesData}
                          onChange={(e) => {
                            hobbiesInputHandler(
                              index,
                              "hobbiestext",
                              e.target.value
                            );
                          }}
                        />
                        <div className="adnew_btn">
                          <Link
                            onClick={() => {
                              deleteHobbiesBlock(index);
                            }}
                            to="#"
                            className="d-inline-flex align-items-center justify-content-center gap-1"
                          >
                            <i className="material-symbols-outlined">delete</i>
                          </Link>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="form-group mb-3">
                  <div className="adnew_btn">
                    <Link
                      to="#"
                      className="d-inline-flex align-items-center justify-content-center gap-1"
                      onClick={addNewHobbiesBlock}
                    >
                      <i className="material-symbols-outlined">add </i>
                      <span>Add New</span>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="process_btns_outer d-flex align-items-center justify-content-between mt-3">
                <button
                  onClick={resetHandler}
                  data-bs-dismiss="modal"
                  className="btn btn-outline-primary"
                >
                  Cancel
                </button>
                <button className="btn btn-primary" onClick={saveInfoHandler}>
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HobbiesModal;
